module.exports = __webpack_public_path__ + "static/annual-report-2018-19-4c225cb77a9d4e3c658e21ecb67d8d6c.pdf";